$(function () {
  $("input[data-approve-box]").keyup(function (event) {
    if ($(event.target).val().toLowerCase() == "approve") {
      $("#approve_all_confirm_submit").removeAttr("disabled");
    } else {
      $("#approve_all_confirm_submit").attr("disabled", true);
    }
  });

  $("a[data-ba-show-alert]").click(function (event) {
    $("#ba-alert-modal").modal("show");
    $("#ba-alert-modal-label").html("Fetching alerts...");
    $("#ba-alert-modal-content").html("");
    $("#ba-alert-modal-spinner").show();
  });

  $("a[data-ba-show-entity]").click(function (event) {
    $("#entity-details-modal").modal("show");
    $("#entity-details-modal-label").html("Fetching entity details...");
    $("#entity-details-modal-content").html("");
    $("#entity-details-modal-spinner").show();
  });

  $("#finish_bulk_approval_button").click(function (event) {
    if ($("#ba_process_deferred_modal").length > 0) {
      $("#ba_process_deferred_modal").modal("show");
      event.preventDefault();
    }
  });

  $('a[data-toggle="tab"]').on("hide.bs.tab", function (e) {
    $("tr.ba-update-highlight").removeClass("ba-update-highlight");
  });
});
